


import { BehaviorSubject, Subject } from 'rxjs'
import _ from 'lodash';
import { alerts} from '../theme';
import { Alert, Storage , Database,} from './exports';
import { createManagerInfo } from '../Utilities';

import { AlertPositions, AUTHENTICATION_STATUS} from '../Constants';
import { isCompositeComponent } from 'react-dom/test-utils';

export class UserManagement {
  status = new BehaviorSubject(null)
  authenticated = new BehaviorSubject(AUTHENTICATION_STATUS.unknown)
  _shouldRelogin = new BehaviorSubject(false)
  _religions = []
  onLogout = new Subject()
  user = null;
  networkConnected = new BehaviorSubject(false)

  constructor(){
    this.managerName = createManagerInfo('USER_MANAGER', 1)  

    
    Storage.init()
    .then(async () =>{
      let status = await Storage.get("authed")
      // console.log("saved status", status)
      if(status) {
        this.authenticated.next(status)
      } else {
        this.authenticated.next(AUTHENTICATION_STATUS.unauthenticated)
      }
    }).catch(console.error)
  }

  
  checkValidProfile = async (email) => {
    try{
     let result = await Database.post('/register', {
        form_stage : "email",
        email
      })
      Storage.set(AUTHENTICATION_STATUS.authenticated, "authed")
      this.authenticated.next(AUTHENTICATION_STATUS.authenticated)
      return !!result
    }catch(e) {
      if(e.status === 401){
        // console.log("returning false")
        return false
      } else {
        return Promise.reject(e.error)
      }
      
    }
  }
  getLogoutNotifications = () => this.onLogout.asObservable()

  _saveAndDistributeUser = async (user = this.user, writeBack = false) => {
    if(_.isEqual(this.user, user)){
      return
    }
    this.user = user
    this.status.next(user)
  }


  _init = _.noop

   _updateConnectionStatus = (value) => {
    this.networkConnected.next(value)
    this._updateShouldLogin()
  }

  getAuthenticationStatus = () => this.authenticated.asObservable()
  getUserProfile = () => this.status.asObservable()
  getUserProfileSnapshot = () => this.user


  _logout = async () => {
    this.user = null
    this.status.next(this.user)
 
    try{
      Storage.set(AUTHENTICATION_STATUS.unauthenticated, "authed")
    } catch(e) {
      // console.log('There was an error clearing Storage', e)
    }

    this.onLogout.next(null)
    this.authenticated.next(AUTHENTICATION_STATUS.unauthenticated)
  }
  
  logout = () => {
    this._logout()
  }

  
  register = async (email, first_name, last_name, phone, zip, country,consent, drawing) => {
    
    let body = {
      email,
      first_name,
      last_name,
      phone, 
      zip,
      country,
      consent,
      drawing
    }
    try{
      Storage.set(AUTHENTICATION_STATUS.authenticated, "authed")
      
      let data = await Database.post('/register', body)
      
      let user = {}
      this._saveAndDistributeUser(user, true)
      this.authenticated.next(AUTHENTICATION_STATUS.authenticated)
      return user
      
    } catch (e) {
        return Promise.reject(e.error)      
    }

  }

  updateProfileImage = async (url) => {
    this.updateUser({image: url})
  }

}



